import { render } from "./RolesDialog.vue?vue&type=template&id=696e374c"
import script from "./RolesDialog.vue?vue&type=script&lang=js"
export * from "./RolesDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__